// src/components/ProductList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ProductList = ({ onProductDeleted, onEditProduct }) => {
  const [products, setProducts] = useState([]);
  const [alert, setAlert] = useState({ message: '', type: '' });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://sribala.hxbindia.com/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://sribala.hxbindia.com/products/${id}`);
      setProducts(products.filter((product) => product._id !== id));
      onProductDeleted();
      setAlert({ message: 'Product deleted successfully!', type: 'success' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    } catch (error) {
      console.error('Error deleting product:', error);
      setAlert({ message: 'Error deleting product.', type: 'danger' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    }
  };

  return (
    <div>
      
<div className="container d-flex justify-content-center ">
<div className="col-md-9 pt-5">
      <h2>Products</h2>
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <ul className="list-group">
   
        {products.map((product) => (
          <li key={product._id} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
            <h6>Product Images</h6>
              {product.image.map((image, index) => (
  <img key={index} src={`https://sribala.hxbindia.com${image}`}  />
))}

              <p><b>Product Name:</b> {product.name}</p>
              <p><b>Details:</b> {product.details}</p>

              <p><b>Description:</b> {product.description}</p>
             
            </div>
            <div>
              <button className="btn btn-warning btn-sm me-2" onClick={() => onEditProduct(product)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(product._id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
      </div>
      </div>
    </div>
  );
};

export default ProductList;
